import { FormControl, FormHelperText, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialInput from "../../../../../../components/MaterialInput";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialBox from "../../../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../../../../components/MasterSelect";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useUserDetails } from "../../../../../../context/auth";
import { useLoading } from "../../../../../../context/loading";

const EmployeeInformation = ({
  role,
  employeeData,
  handleEmployeeDataChange,

  reportManager,
  allbranchnames,

  shiftdata,
  
  togglePage,
  handleChange,
  roledata,
  typedata,
  emptype,

}) => {

  const { validation, validationMessages } = useUserDetails();


  return (
    <Grid container spacing={1}>
      {togglePage.view || togglePage.edit ? (
        <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Employee ID <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <Stack>
            <MaterialInput
              name="employeeId"
              value={employeeData.employeeId}
              // placeholder="Enter a employee id"
              onChange={handleEmployeeDataChange}
              error={employeeData.employeeIdStatus === "error" ? true : false}
              success={
                employeeData.employeeIdStatus === "success" ? true : false
              }
              disabled
            />
           
            {validationMessages.employeeId && (
              <label style={{ color: "red", fontSize: "12px" }}>
                {validationMessages.employeeId}
              </label>
            )}
          </Stack>
        </Grid>
      ) : (
        " "
      )}
      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Joining Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="joiningDate"
          type="date"
          value={employeeData.joiningDate}
          onChange={handleEmployeeDataChange}
          error={employeeData.joiningDateStatus === "error" ? true : false}
          success={employeeData.joiningDateStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            max: new Date().toISOString().split("T")[0], // Today's date
          
          }}
        />

        {validationMessages.joiningDate && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.joiningDate}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Employee Type <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>

        <MaterialSelect
          inputId="employeeType"
          id="employeeType"
          name="employeeType"
          customStyles={{ optionPadding: 20 }}
          value={employeeData.employeeType}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={emptype?.map((value) => {
            return {
              value: value.value,
              label: value.value,
            };
          })}
          error={employeeData.employeeTypeStatus === "error" ? true : false}
          success={employeeData.employeeTypeStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />

        {validationMessages.employeeType && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.employeeType}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Employee Category <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>

        <MaterialSelect
          inputId="categoryType"
          id="categoryType"
          name="categoryType"
          customStyles={{ optionPadding: 20 }}
          value={employeeData.categoryType}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={typedata?.map((value) => {
            return {
              value: value.value,
              label: value.value,
            };
          })}
          error={employeeData.categoryTypeStatus === "error" ? true : false}
          success={employeeData.categoryTypeStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />

        {validationMessages.categoryType && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.categoryType}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Branch <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="branch"
          value={employeeData.branch}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={allbranchnames.map((value) => {
            return {
              value: value.value,
              label: value.label,
            };
          })}
          error={employeeData.branchStatus === "error" ? true : false}
          success={employeeData.branchStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.shifts && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.shifts}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Shifts <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="shifts"
          value={employeeData.shifts}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={shiftdata.map((value) => {
            return {
              value: value.name,
              label: value.name,
            };
          })}
          error={employeeData.shiftsStatus === "error" ? true : false}
          success={employeeData.shiftsStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.shifts && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.shifts}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Role <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="role"
          value={role}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={roledata?.map((value) => {
            return {
              // roleid: value.id,
              value: value.id,
              label: value.role,
            };
          })}
          error={employeeData.roleStatus === "error" ? true : false}
          success={employeeData.roleStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.role && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.role}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Attendance Id 
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="attendanceId"
          placeholder="eg. 12456888"
          value={employeeData.attendanceId}
          onChange={handleEmployeeDataChange}
          error={employeeData.attendanceIdStatus === "error" ? true : false}
          success={employeeData.attendanceIdStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            style: { backgroundColor: "transparent" }, // or your desired color
          }}
        />
      </Grid>

      <Grid sx={{ marginLeft: "2%" }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            OT Applicable
          </MaterialTypography>
        </MaterialBox>
        <FormControlLabel
          sx={{ marginLeft: "10%" }}
          control={
            <Switch
              checked={employeeData.user}
              name="user"
              onChange={handleChange}
              color="primary"
            />
          }
          label={employeeData?.user ? "Yes" : "No"}
          disabled={togglePage.view === true ? true : false}
        />
        {validationMessages.user && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.user}
          </label>
        )}
      </Grid>
      <Grid sx={{ marginLeft: "10%" ,width:"60px"}}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Is User
          </MaterialTypography>
        </MaterialBox>
        <FormControlLabel
          sx={{ marginLeft: "1%" }}
          control={
            <Switch
              checked={employeeData.isuser}
              name="isuser"
              onChange={handleChange}
              color="primary"
            />
          }
          label={employeeData?.isuser ? "Yes" : "No"}
          disabled={togglePage.view === true ? true : false}
        />
        {validationMessages.isuser && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.isuser}
          </label>
        )}
      </Grid>
      <Grid sx={{ marginLeft: "10%" }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Is Active
          </MaterialTypography>
        </MaterialBox>
        <FormControlLabel
          sx={{ marginLeft: "1%" }}
          control={
            <Switch
              checked={employeeData.employee}
              name="employee"
              onChange={handleChange}
              color="primary"
            />
          }
          label={employeeData?.employee ? "Yes" : "No"}
          disabled={togglePage.edit ? false : true}
        />
        {validationMessages.employee && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.employee}
          </label>
        )}
      </Grid>

      {employeeData.employee == false && (
        <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Last Working Day
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="lastworking"
            type="date"
            value={employeeData.lastworking}
            onChange={handleEmployeeDataChange}
            error={employeeData.joiningDateStatus === "error" ? true : false}
            success={
              employeeData.joiningDateStatus === "success" ? true : false
            }
            disabled={togglePage.view === true ? true : false}
            inputProps={{
              min: employeeData.joiningDate,
            }}
          />

          {validationMessages.joiningDate && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.joiningDate}
            </label>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default EmployeeInformation;
